import { render } from "./UserInfoPanel.vue?vue&type=template&id=8be97a86&scoped=true&ts=true"
import script from "./UserInfoPanel.vue?vue&type=script&lang=ts"
export * from "./UserInfoPanel.vue?vue&type=script&lang=ts"

import "./UserInfoPanel.vue?vue&type=style&index=0&id=8be97a86&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be97a86"]])

export default __exports__